/**
 * @author sgdh
 * @description 合同中心枚举
 */

import * as func from '@/func'
const enumToList = func.enumToList()
import { enumToListV } from '@/func/enumToMap'
import type { SelectTypeTm } from '@/func/enumToMap'
import type { DefaultOptionType } from 'ant-design-vue/es/select'

// 合同类型枚举
export enum ContractTypes {
  PURCHASE_CONTRACT = 1,
  SALES_CONTRACT = 2,
}
export enum ContractTypesName {
  PURCHASE_CONTRACT = '采购合同',
  SALES_CONTRACT = '销售合同',
}
export enum MapContractType {
  采购合同 = 1,
  销售合同,
  联营合同,
  合作出版合同,
  服务合同,
  其他合同,
}
// 采购合同类型枚举
export enum SalesDiscountType {
  CONSTANT_DISCOUNT = 1,
  SEQUENTIAL_DISCOUNT = 2,
}
export const MapSalesDiscountType: {
  [key: number]: string
} = {
  [SalesDiscountType.CONSTANT_DISCOUNT]: '固定折扣',
  [SalesDiscountType.SEQUENTIAL_DISCOUNT]: '顺序折扣',
}
export const ListContractType: SelectTypeTm[] = enumToListV(MapContractType)

// 合同状态枚举
export enum ComponentStatus {
  DRAFT = 1,
  // PENDING_REVIEW = 2,
  // REJECTED_FOR_REVIEW = 3,
  PENDING_EFFECTIVENESS = 4,
  EFFECTIVE = 5,
  EXPIRED = 6,
}
export enum ComponentStatusName {
  DRAFT = '草稿',
  // PENDING_REVIEW = '待审核',
  // REJECTED_FOR_REVIEW = '审核驳回',
  PENDING_EFFECTIVENESS = '待生效',
  EFFECTIVE = '已生效',
  EXPIRED = '已失效',
}

export enum ComponentStatusColor {
  DRAFT = 'pink',
  // PENDING_REVIEW = 'red',
  // REJECTED_FOR_REVIEW = 'orange',
  PENDING_EFFECTIVENESS = 'blue',
  EFFECTIVE = 'green',
  EXPIRED = 'red',
}
// 业务关系枚举
export enum BusinessRelations {
  BUSINESS_AGREEMENT = 1,
  CONTRACT_SIGNING = 2,
}
export enum BusinessRelationsName {
  BUSINESS_AGREEMENT = '商业关系',
  CONTRACT_SIGNING = '签订合同',
}
export enum BusinessRelationsColor {
  BUSINESS_AGREEMENT = '#f50',
  CONTRACT_SIGNING = '#87d068',
}

// 采购合同业务属性枚举
export enum PBusinessAttributes {
  INNOVATION = '1',
  EDUCATIONAL_MATERIAL = '2',
  READING_AFFAIRS_DEPARTMENT = '3',
}
export enum PBusinessAttributesName {
  INNOVATION = '创新',
  EDUCATIONAL_MATERIAL = '教材',
  READING_AFFAIRS_DEPARTMENT = '阅读事务部',
}
// 销售合同业务属性枚举
export enum SBusinessAttributes {
  INNOVATION = '1',
  EDUCATIONAL_MATERIAL = '2',
  READING_AFFAIRS_DEPARTMENT = '3',
  ECOMMERCE = '4',
  LIBRARY_SUPPLY = '5',
}
export enum SBusinessAttributesName {
  INNOVATION = '创新',
  EDUCATIONAL_MATERIAL = '教材',
  READING_AFFAIRS_DEPARTMENT = '阅读事务部',
  ECOMMERCE = '电商',
  LIBRARY_SUPPLY = '馆配',
}

// 芸豆属性枚举
export enum BeanAttributes {
  ADVANCE_PAYMENT = 1,
  CREDIT_NOTE = 2,
}
export enum BeanAttributesName {
  ADVANCE_PAYMENT = '预收款',
  CREDIT_NOTE = '白条',
}

// 结算类型枚举
export enum SettlementTypes {
  PAYMENT_TERM = 1,
  REAL_SALES_REAL_SETTLEMENT = 2,
  SETTLEMENT_BY_PROJECT = 3,
}
export enum SettlementTypesName {
  PAYMENT_TERM = '账期',
  REAL_SALES_REAL_SETTLEMENT = '实销实结',
  SETTLEMENT_BY_PROJECT = '按项目结算',
}

// 账期类型枚举
export enum AccountTermType {
  DAY = 1,
  MONTHLY = 2,
  TIME_POINT = 3,
}
export enum AccountTermTypeName {
  DAY = '天',
  MONTHLY = '每月',
  TIME_POINT = '时间点',
}

// 是否枚举
export enum YesOrNo {
  YES = 1,
  NO = 0,
}
export enum YesOrNoName {
  YES = '是',
  NO = '否',
}
export const ListYesOrNo: SelectTypeTm[] = enumToListV(YesOrNo)
// 保证金类型枚举
export enum MarginType {
  PERFORMANCE_BOND = 1,
  AFTER_SALES_GUARANTEE_DEPOSIT = 2,
}
export enum MarginTypeName {
  PERFORMANCE_BOND = '履约保证金',
  AFTER_SALES_GUARANTEE_DEPOSIT = '售后保证金',
}

// 保证金处理类型枚举
export enum MarginProcessing {
  RETURN_ACCORDING_TO_AGREED_TIME = 1,
  PERFORMANCE_BOND_CONVERTED_TO_AFTER_SALES_GUARANTEE_DEPOSIT = 2,
  DEPOSIT_USED_TO_OFFSET_PAYMENT_FOR_GOODS = 3,
}
export enum MarginProcessingName {
  RETURN_ACCORDING_TO_AGREED_TIME = '根据约定时间退还',
  PERFORMANCE_BOND_CONVERTED_TO_AFTER_SALES_GUARANTEE_DEPOSIT = '履约保证金转售后保证金',
  DEPOSIT_USED_TO_OFFSET_PAYMENT_FOR_GOODS = '保证金冲抵货款',
}

// 定金预收规则枚举
export enum PreRules {
  BY_VARIETY = 1,
  BY_PERSONNEL_COUNT = 2,
}
// 定金预收规则枚举
export enum PreRulesName {
  BY_VARIETY = '按品种',
  BY_PERSONNEL_COUNT = '按人数',
}

// 定金预收方式枚举
export enum PreMode {
  FULL_AMOUNT = 1,
  FIXED_AMOUNT = 2,
}
export enum PreModeName {
  FULL_AMOUNT = '全额',
  FIXED_AMOUNT = '固定金额',
}

// 收货对象枚举
export enum Recipient {
  CLIENTS_STUDENTS = '1',
  CLIENTS_EMPLOYEES = '2',
  SELF_SELECTION = '3',
  OTHERS = '4',
}
export enum RecipientName {
  CLIENTS_STUDENTS = '客户的学生',
  CLIENTS_EMPLOYEES = '客户的职工',
  SELF_SELECTION = '自主选择',
  OTHERS = '其他',
}

// 收货方式枚举
export enum DeliveryMethod {
  EXPRESS_DELIVERY = '1',
  SELF_SELECTION = '2',
  OTHERS = '3',
}
export enum DeliveryMethodName {
  EXPRESS_DELIVERY = '快递',
  SELF_SELECTION = '自主选择',
  OTHERS = '其他',
}

// 补充协议类型
export enum MapSupplementaryAgreementType {
  采购折扣 = 1,
  销售折扣,
  联营提点,
  合作分润,
}
export const ListSupplementaryAgreementType = Object.freeze(enumToList({ MapSupplementaryAgreementType })) as DefaultOptionType[]

/**
 * 合同状态 (1-草稿，·2-待审核，3-审核驳回，4-待生效，5-已生效，6-已失效)
 */
export enum MapComponentStatus {
  草稿 = 1,
  // 待审核 = 2,
  // 审核驳回 = 3,
  待生效 = 4,
  已生效 = 5,
  已失效 = 6,
}
export const ListComponentStatus = Object.freeze(enumToList({ MapComponentStatus }))

// 预警类型
export enum MapWarningType {
  合同有效期 = 1,
  协议有效期,
  质保期,
  保证金应收,
  保证金应退,
  付款日期,
}
export const ListWarningType: SelectTypeTm[] = enumToListV(MapWarningType)

// 预警状态
export enum MapWarningStatus {
  已启用 = 1,
  已禁用,
}
export const ListWarningStatus = Object.freeze(enumToList({ MapWarningStatus })) as DefaultOptionType[]

// 合作方类型
export enum MapPartnerType {
  两方 = 1,
  三方,
}

// 审核状态
export enum MapAuditStatus {
  审核中 = 1,
  已通过 = 2,
  已驳回 = 3,
  已撤销 = 4,
}

/**
 * 审核状态颜色（1：审核中 blue 、2：已通过 green、3：已驳回 red、4：已撤销 lime））
 */
export enum MapAuditStatusColor {
  'blue' = 1,
  'green' = 2,
  'red' = 3,
  'lime' = 4,
}
export const ListPartnerType: SelectTypeTm[] = enumToListV(MapPartnerType)
